import moment from 'moment';
import momentDurationFormatSetup from './moment-duration-format';
import './moment-cs-locale';
momentDurationFormatSetup(moment);
